<div>
  <div class="col-sm-12">
    <h4 class="col-sm-auto p-3">Custom Source</h4>
    <div class="row p-3">
      <div class="col-2">
        <mat-form-field appearance="standard">
          <mat-select data-testid="select-option" placeholder="Select Source" [(ngModel)]="sourceSelected">
            <mat-option *ngFor="let stationSource of stationSourceList" [value]="stationSource">{{
              stationSource.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div mat-dialog-actions class="float-right">
    <button data-testid="cancel-dialog" mat-raised-button mat-dialog-close (click)="dialogRef.close(false)">Cancel</button>
    <button data-testid="save-dialog" mat-raised-button color="primary" (click)="addCustomSource()">
      Save
    </button>
  </div>
</div>